import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { ProductChecklist } from "./products-checklist"

export function CreatorProfileProductsSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const products = properties.products

  if (products.length == 0) {
    return null
  }

  return (
    <>
      {products && (
        <div className="mx-4 mb-4">
          <ProductChecklist
            products={products}
            update={update}
            properties={properties}
          />
        </div>
      )}
    </>
  )
}
